import React, { useState, memo } from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import { Menu, MenuItem } from "react-native-material-menu";
import { Feather } from "@expo/vector-icons";
import { useTranslation } from "react-i18next";
import Colors from "../../../Resources/Color";
import GlobalStyles from "../../../Resources/Styles";
import { useDevice } from "../../_layout";

/**
 * LanguagePicker Component
 * A dropdown menu for selecting language between English and Spanish
 * @param {boolean} showGlobe - Whether to show the globe icon (default: false)
 */
const LanguagePicker = ({ showGlobe = false, color = Colors.blackColor }) => {
  const { i18n } = useTranslation();
  const { isMobile } = useDevice();
  const [menuVisible, setMenuVisible] = useState(false);

  const languages = [
    { code: "en", label: "English" },
    { code: "es", label: "Español" },
  ];

  const currentLanguage = languages.find((lang) => lang.code === i18n.language);

  const showMenu = () => setMenuVisible(true);
  const hideMenu = () => setMenuVisible(false);

  const handleLanguageSelect = (languageCode) => {
    i18n.changeLanguage(languageCode);
    // Store in localStorage for persistence
    localStorage.setItem("userLanguage", languageCode);
    hideMenu();
  };

  const LanguageMenuItem = ({ language }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <MenuItem
        onPress={() => handleLanguageSelect(language.code)}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Text
          style={{
            fontSize: 14,
            fontWeight: isHovered ? "600" : "normal",
            color: Colors.blackColor,
          }}
        >
          {language.label}
        </Text>
      </MenuItem>
    );
  };

  return (
    <Menu
      visible={menuVisible}
      anchor={
        <TouchableOpacity onPress={showMenu} style={styles.pickerButton}>
          {showGlobe && (
            <Feather
              name="globe"
              size={16}
              color={color}
              style={{ marginRight: 4 }}
            />
          )}
          <Text style={[styles.pickerText, { color: color }]}>
            {currentLanguage?.label || "English"}
          </Text>
          <Feather name="chevron-down" size={16} color={color} />
        </TouchableOpacity>
      }
      style={GlobalStyles.menu}
      onRequestClose={hideMenu}
    >
      {languages.map((language) => (
        <LanguageMenuItem key={language.code} language={language} />
      ))}
    </Menu>
  );
};

const styles = StyleSheet.create({
  pickerButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 8,
    cursor: "pointer",
  },
  pickerText: {
    fontSize: 14,
    fontWeight: "400",
  },
});

export default memo(LanguagePicker);
